export default function initialize() {
    $('[name=dwfrm_addressInformation_houseNumber], [name=dwfrm_addressInformation_zipcode_zipCode]').blur(() => {
        const url = $('.js-addresslookupurl').val();
        const houseNumber = $('[name=dwfrm_addressInformation_houseNumber]').val();
        const zipCode = $('[name=dwfrm_addressInformation_zipcode_zipCode]').val();
        const $street = $('[name=dwfrm_addressInformation_street]');
        const $city = $('[name=dwfrm_addressInformation_city]');
        if (houseNumber && zipCode) {
            $.ajax({
                url,
                type: 'get',
                data: `code=${zipCode}&nr=${houseNumber}`,
                success: (data) => {
                    $street.val('');
                    $city.val('');
                    let cleanData = data;
                    if (cleanData !== 'null') {
                        if (cleanData.indexOf('(') === 0) {
                            cleanData = cleanData.substr(1);
                        }
                        if (cleanData.lastIndexOf(')') === (cleanData.length - 1)) {
                            cleanData = cleanData.substr(0, cleanData.length - 1);
                        }
                        const response = JSON.parse(cleanData);
                        if (response.Records.length > 0) {
                            const record = response.Records[0];
                            $street.val(record.poco_streetname).closest('.js-input-placeholder').addClass('focus');
                            $city.val(record.poco_city).closest('.js-input-placeholder').addClass('focus');
                        }
                    }
                },
            });
        }
    });
}
